import type { UseFormReturn } from 'react-hook-form';

import { useTranslation } from 'react-i18next';

import { Illustration, Title } from '~/components';

import { CopyrightConditionCards } from './CopyrightConditionCards/CopyrightConditionCards';
import { descriptionStyle, headerStyle, illustrationStyle, sectionStyle } from './CopyrightSection.css';

type FormWithCondition = {
  condition: { id: number; type: 'condition' | 'customAgreement' | 'customCondition' } | null;
  contactId: number | null;
  specialConditions: string;
};

type Props<T extends FormWithCondition> = {
  form: T extends FormWithCondition ? UseFormReturn<T> : never;
  required?: boolean;
};

export const CopyrightSection = <T extends FormWithCondition>({ form, required = true }: Props<T>) => {
  const { t } = useTranslation(['invoices']);

  return (
    <section className={sectionStyle}>
      <div className={headerStyle}>
        <Illustration className={illustrationStyle} name="Stamp" strokeWidth={3} />

        <div>
          <Title as="h2" styleAs="h3">
            {t('invoices:createEdit.conditions.title')}
          </Title>

          <p className={descriptionStyle}>{t('invoices:createEdit.conditions.description')}</p>
        </div>
      </div>

      <CopyrightConditionCards form={form} required={required} />
    </section>
  );
};
